export default __webpack_public_path__ + "static/media/notFound.c0bc7d0b.png";